import { useFocusableDiv } from '../hooks';
import { Control, useController } from 'react-hook-form';

export interface FormFieldProps {
  name: string;
  control: Control;
  disabled?: Boolean;
  label?: string;
  helperText?: string;
}
/**
 * Create control field to use by the form.
 */
export const createControlField = (
  InnerComponent: React.ComponentType<{ value: any; onChange: any }>,
  defaultValue = null
) => ({ name, control, ...props}: FormFieldProps) => {
  const { divRef, focus } = useFocusableDiv();
  const {
    field: { value, onChange },
  } = useController({ name, control, onFocus: focus, defaultValue });
  return (
    <div ref={divRef}>
      <InnerComponent value={value} onChange={onChange} {...props}/>
    </div>
  );
};
